import USER_ACTIONS from '../../actions/user';

const initialState = {
  validUser: false,
  firebaseUser: undefined,
  claims: [],
  selectedOrganisationId: undefined
};

const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_ACTIONS.USER_LOADED:
      return {
        ...state,
        invalidUser: false,
        validUser: true,
        ...action.payload
      };
    case USER_ACTIONS.CLAIMS_LOADED: {
      return {
        ...state,
        claims: action.payload
      };
    }
    case USER_ACTIONS.SWITCH_ORGANISATION:
      return {
        ...state,
        selectedOrganisationId: action.payload.organisationId
      };
    case USER_ACTIONS.FIREBASE_USER_LOADED: {
      return {
        ...state,
        firebaseUser: action.payload
      };
    }
    case USER_ACTIONS.INVALID_USER:
      return {
        ...initialState,
        invalidUser: true,
        validUser: false
      };
    case USER_ACTIONS.USER_LOGOUT:
      return {
        ...initialState,
        invalidUser: state.invalidUser,
        validUser: false
      };
    case USER_ACTIONS.USER_STATS_LOADED:
      return {
        ...state,
        stats: action.payload
      };
    default:
      return state;
  }
};

export default UserReducer;
